import Vue from 'vue';
import api from '../bu/api';
import moment from 'moment';

export default {
	namespaced: true,

	state: () => ({
		campaigns: {},
		campaignsArray: [],
	}),

	getters: {
		campaigns(state) {
			return state.campaignsArray.sort((a, b) => {
				const isExpired = (campaign) => {
					if (campaign.start && campaign.end) {
						const now = moment();
						const end = moment(campaign.end).tz('GMT');
						return now.isAfter(end);
					} else {
						return false;
					}
				}

				a.isExpired = isExpired(a);
				b.isExpired = isExpired(b);

				if (a.isExpired && !b.isExpired) {
					return 1;
				} else if (!a.isExpired && b.isExpired) {
					return -1;
				}

				if (a.enabled !== b.enabled) {
					return b.enabled - a.enabled;
				}
				return b.id - a.id;
			});
		},
		campaignMap(state) {
			return state.campaign;
		},
	},

	actions: {
		async getCampaigns({commit}) {
			const response = await api.getCampaigns();
			commit('setCampaigns', response.data);
		},
		async getAvailableCampaigns({commit}) { // campaign is enabled and if has start and end, end is before now
			const response = await api.getAvailableCampaigns();
			commit('setCampaigns', response.data);
		},
		async saveCampaign({commit}, { campaign }) {
			const response = await api.saveCampaign(campaign);
			commit('setCampaign', response.data);
			return response.data;
		}
	},

	mutations: {
		setCampaign(state, campaign) {
			if (typeof campaign.condition === 'string') {
				campaign.condition = JSON.parse(campaign.condition);
			}
			if (typeof campaign.reward === 'string') {
				campaign.reward = JSON.parse(campaign.reward);
			}
			Vue.set(state.campaigns, campaign.id, campaign);
			Vue.set(state, 'campaignsArray', Object.values(state.campaigns));
		},
		setCampaigns(state, campaigns) {
			state.campaigns = {};
			campaigns.forEach((campaign) => {
				if (typeof campaign.condition === 'string') {
					campaign.condition = JSON.parse(campaign.condition);
				}
				if (typeof campaign.reward === 'string') {
					campaign.reward = JSON.parse(campaign.reward);
				}
				Vue.set(state.campaigns, campaign.id, campaign);
			});
			Vue.set(state, 'campaignsArray', Object.values(state.campaigns));
		},
	},
}